export default "__VITE_ASSET__001fa554__"